import { DrawApi } from '@lib/renderers/pixel'

const localApi = {
  circFillSpots (cx, cy, radius, color1, color2) {
    cx = Math.round(cx)
    cy = Math.round(cy)
    radius = Math.round(radius)
    color1 = Math.round(color1)
    color2 = Math.round(color2)

    for (let y = -radius; y <= radius; y++)
      for (let x = -radius; x <= radius; x++)
        if (x * x + y * y <= radius * radius)
          DrawApi.circFill.call(this, cx + x, cy + y, 1, color1)

    DrawApi.circ.call(this, cx, cy, radius, color1)

    for (let y = -radius; y <= radius; y++)
      for (let x = -radius; x <= radius; x++)
        if (x * x + y * y <= radius * radius) // TODO
          DrawApi.circFill.call(this, cx + x, cy + y, 0, color2) // TODO
  },

  circFillDither (cx, cy, radius, color1, color2) {
    cx = Math.round(cx)
    cy = Math.round(cy)
    radius = Math.round(radius)
    color1 = Math.round(color1)
    color2 = Math.round(color2)

    for (let y = -radius; y <= radius; y++) {
      for (let x = -radius; x <= radius; x++) {
        if (x * x + y * y <= radius * radius) {
          this.setPixel(cx + x, cy + y, ((x + (y % 2)) % 2 === 0) ? color1 : color2)
        }
      }
    }
  },

  rectFillBlinds (x0, y0, x1, y1, color) {
    color = Math.round(color)

    const xa = Math.round(Math.min(x0, x1))
    const ya = Math.round(Math.min(y0, y1))
    const xb = Math.round(Math.max(x0, x1))
    const yb = Math.round(Math.max(y0, y1))

    const w = xb - xa + 1
    let h = yb - ya

    while (h >= 0) {
      if (h % 2 === 0) this.setRow(xa, ya + h, w, color)
      h--
    }
  }
}

export default localApi
